<template>
  <div
    class="container"
    :class="{ 'section-2': nowSectionIsTwo, green: isGreen }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContentWrapper',
  props: {
    nowSection: {
      type: String,
      default: '1',
    },
    isGreen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nowSectionIsTwo() {
      return this.nowSection === '2';
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 85px;
  min-height: 100vh;
  width: 100vw;
  overflow: hidden;
  @media (min-width: 768px) {
    padding-top: 76px;
    padding-left: 302px;
  }
  &.section-2 {
    @media (min-width: 768px) {
      padding-left: 344px;
    }
  }
}

.green {
  background: #77bc1f;
}
</style>
